import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Order } from "../../../../types";

interface OrderStatusDialogProps {
  open: boolean;
  onClose: () => void;
  onUpdate: (status: string) => void;
  selectedOrder: Order | null;
  onOrderChange: (order: Order) => void;
}

const OrderStatusDialog: React.FC<OrderStatusDialogProps> = ({
  open,
  onClose,
  onUpdate,
  selectedOrder,
  onOrderChange,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          bgcolor: "background.paper",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
        {t('admin.updateOrderStatus')}
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }} size="small">
          <InputLabel>{t('admin.newStatus')}</InputLabel>
          <Select
            value={selectedOrder?.status || ""}
            label={t('admin.newStatus')}
            onChange={(e) =>
              selectedOrder && onOrderChange({ ...selectedOrder, status: e.target.value as Order['status'] })
            }
          >
            <MenuItem value="pending">{t('warranty.pending')}</MenuItem>
            <MenuItem value="confirmed">{t('orders.confirmed')}</MenuItem>
            <MenuItem value="shipped">{t('orders.shipped')}</MenuItem>
            <MenuItem value="delivered">{t('orders.delivered')}</MenuItem>
            <MenuItem value="cancelled">{t('orders.cancelled')}</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          onClick={() => onUpdate(selectedOrder?.status || "")}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #00a1cc 0%, #007799 100%)",
            },
          }}
        >
          {t('admin.update')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrderStatusDialog;